<script lang="ts" setup>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { defineProps, defineEmits, ref } from "vue";

const sortby = ref("");
const search = ref("");
const requisitionStatus = ref("");
const requisitionPriority = ref("");
const listRequisitionStatus = [
  { value: "", label: "All Status" },
  { value: "1", label: "Draft" },
  { value: "2", label: "Waiting Approval" },
  { value: "3", label: "Approved" },
  { value: "4", label: "Revision" },
  { value: "5", label: "Declined" },
  { value: "6", label: "Completed" },
];
const listRequisitionPriority = [
  { value: "", label: "All Priority" },
  { value: "1", label: "Regular" },
  { value: "2", label: "Urgent" },
];

const props = defineProps({
  link: {
    type: Object,
    default: null,
  },
  statusFilter: {
    type: Boolean,
    default: true,
  }
});

const emit = defineEmits(["searchByQuery"]);

const buildQuery = () => {
  let queryTemp = "";
  if (search.value != "") {
    queryTemp = queryTemp + "&keyword=" + search.value.toLocaleLowerCase();
  }

  if (sortby.value != "") {
    queryTemp = queryTemp + "&sort_by=" + sortby.value.toLocaleLowerCase();
  }

  if (requisitionStatus.value != "") {
    if (requisitionStatus.value?.value != 0) {
      queryTemp =
        queryTemp + "&requisition_status_id=" + requisitionStatus.value?.value;
    }
  }

  if (requisitionPriority.value != "") {
    if (requisitionPriority.value?.value != 0) {
      queryTemp =
        queryTemp + "&priority=" + requisitionPriority.value?.value;
    }
  }

  emit("searchByQuery", queryTemp);
};
</script>
<template>
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-2">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              v-model="search"
              @keyup="buildQuery"
              placeholder="Search here....."
            />
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="form-group position-relative">
              <vSelect
                v-model="sortby"
                :options="['Name', 'Date']"
                placeholder="Sort By"
                @close="buildQuery"
              ></vSelect>
            </div>
          </div>
        </div>
        <div class="col" v-if="props?.link != null">
          <a
            class="btn btn-outline-primary py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
            :href="props?.link?.url"
          >
            <span class="py-sm-1 d-block">
              <i class="ri-add-line d-none d-sm-inline-block me-1"></i>
              <span>{{ props?.link?.text }}</span>
            </span>
          </a>
        </div>
        <div class="col" v-if="props.statusFilter">
          <div class="form-group">
            <div class="form-group position-relative">
              <vSelect
                v-model="requisitionStatus"
                :options="listRequisitionStatus"
                placeholder="Status"
                @close="buildQuery"
              ></vSelect>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="form-group position-relative">
              <vSelect
                v-model="requisitionPriority"
                :options="listRequisitionPriority"
                placeholder="Priority"
                @close="buildQuery"
              ></vSelect>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
